<div *ngIf="isLoading">Loading Income Type List...</div>

<select *ngIf="!isLoading" [compareWith]="byId" class="form-control" name="incomeType"
        [(ngModel)]="model.incomeType" [required]="required">
  <option *ngFor="let singleIncomeType of incomeTypes" [ngValue]="singleIncomeType">{{ singleIncomeType.name
    }}
  </option>
</select>
